import { SyntheticEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SimpleNode } from '../../models/models';
import {
    clearNodeSelected,
    getMyNodesStart,
    getNodeStart,
} from '../../store/node/node.action';
import { selectNodeSelected } from '../../store/node/node.selector';
import {
    clearNodeProjectSelected,
    getProjectStart,
} from '../../store/project/project.action';
import { selectProjectSelected } from '../../store/project/project.selector';
import NodeAccordionDetails from './node-accordion-details/node-accordion-details.component';
import NodeAccordionSummary from './node-accordion-summary/node-accordion-summary.component';
import { CustomAccordion } from './node-accordion.styles';
const NodeAccordion = ({ node }: { node: SimpleNode }) => {
    const nodeSelected = useSelector(selectNodeSelected);
    const projectSelected = useSelector(selectProjectSelected);

    const dispatch = useDispatch();

    const handleChange =
        () => (event: SyntheticEvent, newExpanded: boolean) => {
            if (newExpanded) {
                if (!projectSelected) {
                    dispatch(getProjectStart(node.project.id, node.id));
                }
                dispatch(getNodeStart(node.id));
            } else {
                dispatch(clearNodeSelected());
                dispatch(clearNodeProjectSelected());
                dispatch(
                    getMyNodesStart(projectSelected ? projectSelected.id : null)
                );
            }
        };

    return (
        <CustomAccordion
            expanded={node.id === nodeSelected?.id}
            onChange={handleChange()}
            nodeStatus={
                node.id === nodeSelected?.id
                    ? nodeSelected.status.key
                    : node.status.key
            }
        >
            <NodeAccordionSummary node={node} />
            <NodeAccordionDetails node={node} />
        </CustomAccordion>
    );
};

export default NodeAccordion;
